module.exports = __webpack_public_path__ + "img/slide5.2af9b7be.png";